export enum PcsEnrolmentVerificationStatusEnum {
    Unverified = "Unverified",
    InProgress = "In-progress",
    Adherent = "Adherent",
    RequiresFurtherAction = "Requires further action",
    NonAdherent = "Non-adherent"
}